const SET_FETCHING = 'mrDistribution/SET_FETCHING';
const SET_SUBMITTING = 'mrDistribution/SET_SUBMITTING';

export default {
  SET_FETCHING,
  SET_SUBMITTING,
};
